
import { Observable,  of as observableOf } from "rxjs";

import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, map } from "rxjs/operators";
import { GlobalMessageActions } from "../../../../global-message/actions/global-message-actions";
import { ContactActions } from "../actions/contact-actions";
import { ContactService } from "../services/contact-service";

@Injectable()
export class ContactEpics {

    constructor(private router: Router,
                private contactService: ContactService) {
    }

    getContactEpic = (action$) => {
        return action$.ofType(ContactActions.GET_CONTACT)
            .switchMap((action) => this.contactService.getContact(action.payload).pipe(
                map((response) => {
                    return { type: ContactActions.GET_CONTACT_SUCCESS, payload: response};
                })));
    };

    createContactEpic = (action$) => {
        return action$.ofType(ContactActions.SAVE_CONTACT)
            .switchMap((action) => this.contactService.createContact(action.payload).pipe(
                map((response) => {
                    const redirectUrlParts = this.router.url.split("/");
                    const redirectUrl = redirectUrlParts.slice(0, redirectUrlParts.length - 2).join("/");

                    this.router.navigate([redirectUrl]);

                    return {
                        type: GlobalMessageActions.SHOW_MESSAGE,
                        status: "SUCCESS",
                        response,
                    };
                }),
                catchError((response) => {
                    return observableOf({
                        type: GlobalMessageActions.SHOW_MESSAGE,
                        status: "ERROR",
                        response,
                    });
                })));
    };

    updateContactEpic = (action$) => {
        return action$.ofType(ContactActions.UPDATE_CONTACT)
            .switchMap((action) => this.contactService.updateContact(action.payload).pipe(
                map((response) => {
                    const redirectUrlParts = this.router.url.split("/");
                    const redirectUrl = redirectUrlParts.slice(0, redirectUrlParts.length - 2).join("/");

                    this.router.navigate([redirectUrl]);

                    return {
                        type: GlobalMessageActions.SHOW_MESSAGE,
                        status: "SUCCESS",
                        response,
                    };
                }),
                catchError((response) => {
                    return observableOf({
                        type: GlobalMessageActions.SHOW_MESSAGE,
                        status: "ERROR",
                        response,
                    });
                })));
    };
};
